const DAY = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' })

/** "Oct 20", from a `YYYY-MM-DD` calendar date. Formatted at UTC from the date's own parts so no zone shifts it. */
export function shortDay(date: string): string {
  return DAY.format(Date.UTC(Number(date.slice(0, 4)), Number(date.slice(5, 7)) - 1, Number(date.slice(8, 10))))
}
